<template lang="pug">
  modal-dialog(modal-scale="large")
    .modal-box
      .modal-header
        .modal-card-title
          span 核销信息
        .close-button(@click="modalClose")
      .modal-body
        .order-no
          .title 订单编号
          .no {{info_c.third_order_no}}
        .table-wrapper
          table.table
            thead
              tr
                td
                td(width="150") 商品服务信息
                td(width="50") 价格
                td(width="100") 购买数量
                td(width="110") 可核销数量
                td(width="150") 核销数量
            tbody
              tr(v-for="(item,index) in info_c.order_item")
                td
                  .service-item-detail
                    .item-image
                      img(:src="scaleImage(item.item_image, 1, 40, 40)")
                td
                  .good-name {{item.item_title}}
                td
                  .simple-td  {{accDiv(item.sell_price, 100)}}
                td
                  .simple-td  {{item.quantity}}
                td
                  .simple-td {{item.quantity - item.write_num}}
                td
                  .ctrl-box
                    .btn.left.disabled-btn(v-if="item.number<=0") -
                    .btn.left(v-if="item.number>0" @click="addNumber(-1,index)") -
                    .value {{item.number}}
                    .btn.right.disabled-btn(v-if="item.number >= 1") +
                    .btn.right(v-if="item.number < 1" @click="addNumber(1,index)") +
        .client-info
          .serivce-ticket-item
            .label.client  客户信息
          .infoes
            img(:src="scaleImage('https://chedian-oss1.vchangyi.com/jd-tx.png', 1, 36, 36)")
            div
              div 京东客户
              div {{info_c.mobile}}
        .table-wrapper(v-if="selected_item.length>0")
          table.table
            thead
              tr
                td(width="150") 商品服务信息
                td(width="150") 核销数量
            tbody
              tr(v-for="item in info_c.order_item")
                td
                  .service-item-detail
                    .item-image
                      img(:src="scaleImage(item.item_image, 1, 40, 40)")
                    div {{item.item_title}}
                td
                  .simple-td 1
        .modal-footer
          button.button.large.primary(@click="writeOffProjectNum" v-if="selected_item.length>0") 确认核销
          span.cancel-button(@click="modalClose") 取消
</template>

<script>
import ModalDialog from '@/components/generics/ModalDialog'
import modalInteractions from '@/mixins/utilities/modalInteractions'
import workbenchMixin from '@/mixins/modules/workbench'
import imageScale from '@/mixins/utilities/imageScale'
import MathFun from '@/mixins/utilities/math'
export default {
  name: 'JdWriteModal',
  mixins: [modalInteractions, workbenchMixin, imageScale, MathFun],
  components: { ModalDialog },
  props: {
    info: {},
  },
  data () {
    return {
      info_c: { order_item: [] },
    }
  },
  mounted () {
    this.info_c = { ...this.info }
  },
  computed: {
    selected_item () {
      return this.info_c.order_item.filter(i => {
        return i.number > 0
      })
    },
  },
  methods: {
    async writeOffProjectNum () {
      try {
        let param = {
          parent_no: this.info_c.third_order_no,
          write_code: this.info_c.write_code,
        }
        const { response, result } = await this.JDWriteOffApi(param)
        if (response.status === 200 && result.code === 0) {
          this.$store.dispatch('showMessage', {
            type: 'success',
            title: '核销成功',
            duration: 1500,
            autoClose: true,
          })
          setTimeout(() => {
            this.$emit('success')
            this.modalClose()
          }, 1500)
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '核销失败',
            content: result.message,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '核销失败',
          content: `出错啦！错误码： ${err}`,
        })
      }
    },
    addNumber (num, index) {
      this.info_c.order_item = this.info_c.order_item.map((v, i) => {
        if (i === index) {
          v.number = Number(num) + Number(v.number)
        }
        return v
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/modules/service-ticket.styl'
.header
  padding 24px
  border-bottom 1px solid #f0f0f0
  font-size 20px
  color #353535
  line-height 24px
.order-no
  padding-top 24px
  padding-left 16px
  border-bottom 1px solid #f0f0f0
  min-height 88px
  line-height 24px
  margin-bottom 5px
  .title
    font-size 14px
    color #999
  .no
    font-size 16px
    color #353535
.table-wrapper
  padding 0 10px
  border-bottom 1px solid #f0f0f0
  td
    padding 0 0 0 13px !important
.service-item-detail
  line-height 40px
  height 40px
.ctrl-box
  display flex
  align-items center
  .btn
    box-sizing border-box
    width 31px
    height 30px
    line-height 30px
    text-align center
    background-color #fdfdfd
    cursor pointer
    border 1px solid #c2c2c2
  .value
    box-sizing border-box
    border-top 1px solid #c2c2c2
    border-bottom 1px solid #c2c2c2
    width 50px
    line-height 28px
    height 30px
    background-color #fafafa
    cursor not-allowed
    text-align center
  .disabled-btn
    cursor not-allowed
.client-info
  padding 0 10px
  display flex
  border-bottom 1px solid #f0f0f0
  .infoes
    margin-left 120px
    display flex
    align-items center
    font-size 13px
    line-height 22px
    div
      margin-left 10px
    .tel
      margin-top 5px
    img
      border-radius 18px
.modal-body
  max-height 300px
  overflow-y scroll
</style>



// WEBPACK FOOTER //
// src/components/workbench/model/JdWriteModal.vue